// extracted by mini-css-extract-plugin
export default {"smallWidget":"smallWidget_smallWidget__iA436","header":"smallWidget_header__sS6QZ","content":"smallWidget_content__iPLBE"};